import React from "react";
import { FormGroupConfig } from "../types.d";
import classNames from "classnames";

//TODO: SF/SR update css
function FormGroup(props: FormGroupConfig) {
  const computedClassNames = React.useMemo(
    () =>
      classNames(props.className, {
        form_item: true,
        [`form_item--fullWidth`]: props.fullWidth,
        indented: props.indented
      }),
    [props.className, props.fullWidth, props.indented]
  );

  return <div className={computedClassNames}>{props.children}</div>;
}

export default FormGroup;
